import type { LeadSource } from '@nexofacil/schemas';

/** Capture UTM params, fbclid, referrer and the landing URL at form load time. */
export function captureSource(): LeadSource {
  const url = new URL(window.location.href);
  const p = url.searchParams;
  return {
    utmSource: p.get('utm_source') ?? undefined,
    utmMedium: p.get('utm_medium') ?? undefined,
    utmCampaign: p.get('utm_campaign') ?? undefined,
    utmTerm: p.get('utm_term') ?? undefined,
    utmContent: p.get('utm_content') ?? undefined,
    fbclid: p.get('fbclid') ?? undefined,
    referrer: document.referrer || undefined,
    landingUrl: window.location.href,
  };
}
